import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import ja from './locales/ja'

Vue.use(VueI18n)

const savedLang = localStorage.getItem('lang') || 'ja'

export default new VueI18n({
    locale: savedLang,
    fallbackLocale: 'ja',
    messages: { zh, ja }
})